<ng-template [ngIf]="loaded$ | async" [ngIfElse]="loading">
  <ng-container *ngIf="isLocaleSet">
    <py-storefront></py-storefront>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div>Loading...</div>
</ng-template>
